function o(n) {
  const t = n.toLowerCase().match(/\.([0-9a-z]+)(?:[?#]|$)/);
  return t === null ? null : t[t.length - 1];
}
function e(n, i) {
  if (!n) return !1;
  const t = o(n);
  return i.some((r) => r === t);
}
function s(n) {
  return e(n, [
    "jpeg",
    "jpg",
    "png",
    "gif",
    "bmp",
    "tiff",
    "tif",
    "webp",
    "avif",
    "ico",
    "apng",
    "svg"
  ]);
}
function u(n) {
  return e(n, [
    "txt",
    "rtf",
    "md",
    "tex",
    "doc",
    "docx",
    "odt"
  ]);
}
function c(n) {
  return e(n, ["ppt", "pptx", "odp"]);
}
function f(n) {
  return e(n, ["zip", "gz"]);
}
function a(n) {
  return e(n, ["csv", "xls", "xlsx", "ods"]);
}
export {
  o as getExtension,
  e as hasExtension,
  f as isArchive,
  s as isImage,
  c as isPresentation,
  a as isSpreadsheet,
  u as isTextDocument
};
